import 'jquery.toc/jquery.toc.js'

$(document).ready(function () {
    // scroll to top *jquery for smoother scroll animation
    $('.single-post-jump-sec__list a').on('click', function (e) {
        e.preventDefault();

        let target = this.getAttribute('href');

        if (target) {
            let $targetElement = $(target.replace(/[\\^$*+?.()|[\]{}&\/,:®'!]/g, '\\$&'));

            if ($targetElement.length) {
                $('html, body').animate({ scrollTop: $targetElement.offset().top - 200 }, 2000);
                $('.js-jl-trigger-accordion').click();
            }
        }
    });
});

$(function () {
    function initAccordion(trigger, activeItemFirst, activeItemClass, allItemsHidden) {
        trigger.on('click', function H() {
            let self = $(this);

            trigger.not(self).siblings().slideUp(400);
            self.parent().siblings().removeClass(`${activeItemClass}`);

            if (self.parent().hasClass(`${activeItemClass}`)) {
                self.siblings().slideUp(400);
                self.parent().removeClass(`${activeItemClass}`);
            } else {
                $(this).siblings()
                    .slideDown(400);
                $(this).parent().addClass(`${activeItemClass}`);
            }
        });

        if(allItemsHidden != true) {
            if (activeItemFirst) {
                activeItemFirst.first().find(trigger).siblings().slideDown(400);
                activeItemFirst.first().addClass(`${activeItemClass}`);
            }
        }
    }

    initAccordion($('.js-jl-trigger-accordion'), $('.js-jl-accordion-item'), 'active', true);
});
